<template>
    <div>
        <encabezado-filtros
            titulo="Usuarios"
            :subtitulo="`${usuarios.length} usuarios del sistema`"
            v-model:busqueda="busqueda"
            placeholder-busqueda="Buscar por nombre o usuario"
        >
            <template v-slot:acciones>
                <v-btn color="primary" to="/nuevo-usuario">
                    <v-icon start>mdi-plus</v-icon>
                    Nuevo usuario
                </v-btn>
            </template>
        </encabezado-filtros>

        <v-card variant="outlined" rounded="lg">
        <v-data-table
        :loading="cargando"
        :headers="encabezadoTabla"
        :items="usuarios"
        item-key="id"
        :search="busqueda"
        sort-by="nombre"
        :footer-props="{itemsPerPageText: 'Por página'}"
        >
        <template v-slot:[`item.nombre`]="{ item }">
            <div class="d-flex align-center py-1" style="gap: 12px">
                <v-avatar size="34" color="primary" variant="tonal">
                    <span class="text-caption font-weight-bold">{{ iniciales(item.nombre) }}</span>
                </v-avatar>
                <div>
                    <div class="font-weight-medium">{{ item.nombre }}</div>
                    <div class="text-caption text-muted">{{ item.usuario }}</div>
                </div>
            </div>
        </template>

        <template v-slot:[`item.opciones`]="{ item }">
            <v-tooltip location="bottom" color="primary">
                <template v-slot:activator="{ props }">
                    <v-btn
                        icon="mdi-pencil"
                        color="primary"
                        size="small"
                        variant="text"
                        v-bind="props"
                        @click="editar(item.id)"
                    ></v-btn>
                </template>
                <span>Editar</span>
            </v-tooltip>
            <v-tooltip location="bottom" color="error">
                <template v-slot:activator="{ props }">
                    <v-btn
                        icon="mdi-delete"
                        color="error"
                        size="small"
                        variant="text"
                        v-bind="props"
                        @click="eliminar(item)"
                    ></v-btn>
                </template>
                <span>Eliminar</span>
            </v-tooltip>
        </template>
        </v-data-table>
        </v-card>

        <v-dialog v-model="mostrarDialogoEliminar" max-width="500px">
            <dialogo-eliminar :nombre="itemSeleccionado" @cancelar="cerrarDialogoEliminar" @eliminar="confirmarEliminar"/>
        </v-dialog>
        <v-snackbar
        v-model="mostrarMensaje"
        :timeout="3000"
        :color="mensaje.color"
        location="top"
        >
            {{ mensaje.texto }}
        </v-snackbar>
    </div>
</template>
<script>
import DialogoEliminar from '../Dialogos/DialogoEliminar.vue'
import HttpService from '../../Servicios/HttpService'
import EncabezadoFiltros from '../Dialogos/EncabezadoFiltros.vue'

export default {
    name: "Usuarios",
    components: { DialogoEliminar, EncabezadoFiltros },

    data: () => ({
        busqueda: "",
        cargando: false,
        mostrarDialogoEliminar: false,
        usuario: {},
        usuarios: [],
        encabezadoTabla: [
            {title: "Usuario", sortable: true, key: "nombre"},
            {title: "Teléfono", key: "telefono"},
            {title: 'Opciones', key: 'opciones', sortable: false },
            ],
        itemSeleccionado: "",
        mensaje: {
            texto: "",
            color: ""
        },
        mostrarMensaje: false
    }),

    mounted(){
        this.obtenerUsuarios()
    },

    methods:{
        iniciales(nombre) {
            if (!nombre) return "";
            return nombre
                .split(" ")
                .filter(Boolean)
                .slice(0, 2)
                .map((parte) => parte[0].toUpperCase())
                .join("");
        },

        editar(idUsuario){
            this.$router.push({
                name: "EditarUsuario",
                params: { id: idUsuario },
            })
        },

        eliminar(usuario){
            this.itemSeleccionado = usuario.nombre
            this.usuario = usuario
            this.mostrarDialogoEliminar = true
        },

        cerrarDialogoEliminar(){
            this.mostrarDialogoEliminar = false
            this.usuario = {}
        },

        confirmarEliminar(){
            this.cargando = true
            let payload = {
                metodo: "delete",
                id: this.usuario.id
            }
            HttpService.eliminar("usuarios.php", payload)
            .then(eliminado => {
                if(eliminado){
                    this.mostrarDialogoEliminar = false
                    this.mostrarMensaje = true
                    this.mensaje.texto = "Usuario eliminado"
                    this.mensaje.color = "success"
                    this.cargando = false
                    this.obtenerUsuarios()
                }
            })
        },



        obtenerUsuarios(){
            this.cargando = true
            let payload = {metodo: "get"}
            HttpService.obtenerConDatos(payload, "usuarios.php")
            .then(respuesta => {
                this.usuarios = respuesta
                this.cargando = false
            })
        }
    }
}
</script>
